<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        系统首页
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto ;">
      <div class="pandect">
        <div class="pandect_list">
          <div class="pandect_icon">
            <i class="far fa-list-alt fa-3x"></i>
          </div>
          <div class="pandect_center">
            <p>今日订单总数</p>
            <p>平台：<span class="num">{{today_order_number}}</span></p>
            <p>店铺：<span class="num">{{today_shop_order_number}}</span></p>
          </div>
        </div>
        <div class="pandect_list">
          <div class="pandect_icon">
            <i class="fas fa-donate fa-3x"></i>
          </div>
          <div class="pandect_center">
            <p>今日订单总金额</p>
            <p>平台：<span class="num">{{today_order_money}}</span></p>
            <p>店铺：<span class="num">{{today_shop_order_money}}</span></p>
          </div>
        </div>
        <div class="pandect_list">
          <div class="pandect_icon">
            <i class="fas fa-receipt fa-3x"></i>
          </div>
          <div class="pandect_center">
            <p>昨日销售额</p>
            <!-- <span>{{yesterday_order_money}}</span> -->
            <p>平台：<span class="num">{{yesterday_order_money}}</span></p>
            <p>店铺：<span class="num">{{shop_yesterday_order_money}}</span></p>
          </div>
        </div>
        <div class="pandect_list">
          <div class="pandect_icon">
            <i class="fas fa-sort-amount-up fa-3x"></i>
          </div>
          <div class="pandect_center">
            <p>近七天销售总额</p>
            <!-- <span>{{seven_days_money}}</span> -->
            <p>平台：<span class="num">{{seven_days_money}}</span></p>
            <p>店铺：<span class="num">{{shop_seven_days_money}}</span></p>
          </div>
        </div>
      </div>
      <div class="pending">
        <div class="pending_head">待处理事务</div>
        <div class="pending_center">
          <div class="pending_center_div">
            <div class="pending_center_div1">
              <router-link to="/admin/d_orderlist?type=0" target="_blank">
                <el-link>待付款订单</el-link>
              </router-link>

              <span>
                (
                <i>{{status0}}</i>
                )
              </span>
            </div>
            <div class="pending_center_div1">
              <router-link to="/admin/d_orderlist?type=1" target="_blank">
                <el-link>待采购订单</el-link>
              </router-link>

              <span>
                (
                <i>{{status1}}</i>
                )
              </span>
            </div>
          </div>
          <div class="pending_center_div">
            <div class="pending_center_div1">
              <router-link to="/admin/d_orderlist?type=2" target="_blank">
                <el-link>待发货订单</el-link>
              </router-link>

              <span>
                (
                <i>{{status2}}</i>
                )
              </span>
            </div>
            <div class="pending_center_div1">
              <router-link to="/admin/d_orderlist?type=3" target="_blank">
                <el-link>待收货订单</el-link>
              </router-link>

              <span>
                (
                <i>{{status3}}</i>
                )
              </span>
            </div>
          </div>
          <div class="pending_center_div">
            <div class="pending_center_div1">
              <router-link to="/admin/d_orderlist?type=4" target="_blank">
                <el-link>待评价订单</el-link>
              </router-link>

              <span>
                (
                <i>{{status4}}</i>
                )
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="pending">
        <div class="pending_head">运营快捷入口</div>
        <div class="pending_center">
          <router-link to="./list" tag="div" class="pending_center_div2">
            <i class="far fa-plus-square fa-4x" style=" margin-top:32px;"></i>
            <p>添加商品</p>
          </router-link>
          <router-link to="./d_orderList" tag="div" class="pending_center_div2">
            <i class="far fa-list-alt fa-4x" style=" margin-top:32px;"></i>
            <p>订单列表</p>
          </router-link>
          <router-link to="./y_userList" tag="div" class="pending_center_div2">
            <i class="fas fa-user-cog fa-4x" style=" margin-top:32px;"></i>
            <p>用户管理</p>
          </router-link>
          <router-link to="./c_integral" tag="div" class="pending_center_div2">
            <i class="far fa-clock fa-4x" style=" margin-top:32px;"></i>
            <p>秒杀管理</p>
          </router-link>
          <router-link to="./groupList" tag="div" class="pending_center_div2">
            <i class="fas fa-shield-alt fa-4x" style=" margin-top:32px;"></i>
            <p>权限管理</p>
          </router-link>
        </div>
      </div>
      <div class="comm">
        <div class="comm_div">
          <div class="comm_head">商品总览</div>
          <div class="comm_center comm_m_top">
            <div>
              <p>平台：<span class="num">{{not_selling}}</span></p>
              <p>店铺：<span class="num">{{shop_not_selling}}</span></p>
              <p>已下架</p>
            </div>
            <div>
              <p>平台：<span class="num">{{selling}}</span></p>
              <p>店铺：<span class="num">{{shop_selling}}</span></p>
              <p>已上架</p>
            </div>

            <div>
              <p>平台：<span class="num">{{product}}</span></p>
              <p>店铺：<span class="num">{{shop_product}}</span></p>
              <p>全部商品</p>
            </div>
          </div>
        </div>
        <div class="comm_div">
          <div class="comm_head">用户总览</div>
          <div class="comm_center">
            <div>
              <span>{{today_user}}</span>
              <p>今日新增</p>
            </div>
            <div>
              <span>{{yesterday_user}}</span>
              <p>昨日新增</p>
            </div>
            <div>
              <span>{{now_month_user}}</span>
              <p>本月新增</p>
            </div>
            <div>
              <span>{{all_user}}</span>
              <p>会员总数</p>
            </div>
          </div>
        </div>
      </div>
      <div class="order">
        <div class="order_head">订单统计</div>
        <div class="order_center">
          <div class="order_left">
            <div class="order_left_top">
              <div class="order_left_top1">本周订单总数</div>
              <div class="order_left_top2">{{now_week}}</div>
              <div class="order_left_top3">
                <span style="color:#3498DB" v-if="now_week  > last_week">
                  <i class="fas fa-long-arrow-alt-up" style="font-size:16px;"></i>
                  {{Math.abs(parseInt((now_week - last_week)/last_week*100))}}%
                </span>
                <span style="color:#F64E62" v-if="now_week  < last_week">
                  <i class="fas fa-long-arrow-alt-down" style="font-size:16px;"></i>
                  {{Math.abs(parseInt((now_week - last_week)/last_week*100))}}%
                </span>
                <span style="color:rgba(153,153,153,1);">同比上周</span>
              </div>
            </div>
            <div class="order_left_but">
              <div class="order_left_top1">本月订单总数</div>
              <div class="order_left_top2">{{now_month}}</div>
              <div class="order_left_top3">
                <span v-if="now_month > last_month" style="color:#3498DB">
                  <i class="fas fa-long-arrow-alt-up" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_month - last_month)/last_month*100))}}%
                </span>
                <span v-if="now_month < last_month" style="color:#F64E62">
                  <i class="fas fa-long-arrow-alt-down" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_month - last_month)/last_month*100))}}%
                </span>
                <span style="color:rgba(153,153,153,1);">同比上月</span>
              </div>
            </div>
          </div>
          <div class="order_right">
            <div class="statistics">
              <div class="statistics_left">
                <div>近一周订单统计</div>
              </div>
              <div class="statistics_rig_yeay">
                <span @click="setData" :class="{active :stuct}">本周</span>
                <span @click="setData1" :class="{active :stuct1}">本月</span>
                <span @click="setData2" :class="{active :stuct2}">本年</span>
              </div>
              <div class="statistics_rig">
                <div class="container">
                  <div class="container">
                    <div class="block">
                      <span class="demonstration">年</span>
                      <el-date-picker
                        @change="year"
                        size="mini"
                        v-model="year1"
                        type="year"
                        placeholder="选择年"
                        style="width:140px"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div class="block">
                    <span class="demonstration">月</span>
                    <el-date-picker
                      size="mini"
                      v-model="month1"
                      type="month"
                      placeholder="选择月"
                      style="width:140px"
                      @change="month"
                    ></el-date-picker>
                  </div>
                  <div class="block">
                    <span class="demonstration">周</span>
                    <el-date-picker
                      v-model="week1"
                      size="mini"
                      type="week"
                      format="yyyy 第 WW 周"
                      placeholder="选择周"
                      style="width:140px"
                      @change="week"
                    ></el-date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <chart :styles="myStyles" v-bind:data="chartData"></chart>
            </div>
          </div>
        </div>
      </div>
      <div class="order">
        <div class="order_head">销售统计</div>
        <div class="order_center">
          <div class="order_left">
            <div class="order_left_top">
              <div class="order_left_top1">本周销售总额</div>
              <div class="order_left_top2">{{now_week_money}}</div>
              <div class="order_left_top3">
                <span style="color:#3498DB" v-if="now_week_money > last_week_money">
                  <i class="fas fa-long-arrow-alt-up" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_week_money - last_week_money)/last_week_money*100))}}%
                </span>
                <span v-if="now_week_money < last_week_money" style="color:#F64E62">
                  <i class="fas fa-long-arrow-alt-down" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_week_money - last_week_money)/last_week_money*100))}}%
                </span>
                <span style="color:rgba(153,153,153,1);">同比上周</span>
              </div>
            </div>
            <div class="order_left_but">
              <div class="order_left_top1">本月销售总额</div>
              <div class="order_left_top2">{{now_month_money}}</div>
              <div class="order_left_top3">
                <span style="color:#3498DB" v-if="now_month_money > last_month_money">
                  <i class="fas fa-long-arrow-alt-up" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_month_money - last_month_money)/last_month_money*100))}}%
                </span>
                <span v-if="now_month_money < last_month_money" style="color:#F64E62">
                  <i class="fas fa-long-arrow-alt-down" style="font-size:16px"></i>
                  {{Math.abs(parseInt((now_month_money - last_month_money)/last_month_money*100))}}%
                </span>
                <span style="color:rgba(153,153,153,1);">同比上月</span>
              </div>
            </div>
          </div>
          <div class="order_right">
            <div class="statistics">
              <div class="statistics_left">
                <div>近一周销售统计</div>
              </div>
              <div class="statistics_rig_yeay">
                <span @click="setDatas" :class="{active1 :stuct01}">本周</span>
                <span @click="setDatas1" :class="{active1 :stuct11}">本月</span>
                <span @click="setDatas2" :class="{active1 :stuct21}">本年</span>
              </div>
              <div class="statistics_rig">
                <div class="container">
                  <div class="container">
                    <div class="block">
                      <span class="demonstration">年</span>
                      <el-date-picker
                        @change="years"
                        size="mini"
                        v-model="years1"
                        type="year"
                        placeholder="选择年"
                        style="width:140px"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="block">
                    <span class="demonstration">月</span>
                    <el-date-picker
                      size="mini"
                      v-model="months1"
                      type="month"
                      placeholder="选择月"
                      style="width:140px"
                      @change="months"
                    ></el-date-picker>
                  </div>
                  <div class="block">
                    <span class="demonstration">周</span>
                    <el-date-picker
                      v-model="weeks1"
                      size="mini"
                      type="week"
                      format="yyyy 第 WW 周"
                      placeholder="选择周"
                      style="width:140px"
                      @change="weeks"
                    ></el-date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <chart1 :styles="myStyles" v-bind:data="chartDatas"></chart1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else>

    </noAccess>
  </div>
</template>

<script>
import Chart from "../components/chart.vue";
import Chart1 from "../components/chart1.vue";
export default {
  components: {
    Chart,
    Chart1
  },
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      stuct: true,
      stuct1: false,
      stuct2: false,
      stuct01: true,
      stuct11: false,
      stuct21: false,
      week1: "",
      weeks1: "",
      month1: "",
      months1: "",
      year1: "",
      years1: "",
      token: "",
      username: "",
      dataBal: [],
      chartData: [],
      chartDatas: [],
      dataBals: [],
      all_user: "",
      last_month: "",
      last_week: "",
      not_selling: "",
      now_month: "",
      now_week: "",
      product: "",
      selling: "",
      seven_days_money: "",
      status0: "",
      status1: "",
      status2: "",
      status3: "",
      status4: "",
      status5: "",
      status6: "",
      today_order_money: 0,
      today_order_number: 0,
      today_shop_order_money: 0,
      today_shop_order_number: 0,
      shop_seven_days_money: 0,
      shop_yesterday_order_money: 0,
      shop_selling: 0,
      shop_not_selling: 0,
      shop_product: 0,
      today_user: "",
      yesterday_order_money: "",
      yesterday_user: "",
      now_week_money: "",
      last_week_money: "",
      now_month_money: "",
      last_month_money: "",
      now_month_user: ""
    };
  },
  methods: {
    geting() {
      // this.$store.state.left = "系统首页";

      const that = this;
      this.axios
        .get(this.serve + "/admin/adminIndex", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            that.all_user = json.all_user;
            that.last_month = json.last_month;
            that.last_week = json.last_week;
            that.not_selling = json.not_selling;
            that.now_month = json.now_month;
            that.now_week = json.now_week;
            that.product = json.product;
            that.selling = json.selling;
            that.seven_days_money = json.seven_days_money;
            that.status0 = json.status0;
            that.status1 = json.status1;
            that.status2 = json.status2;
            that.status3 = json.status3;
            that.status4 = json.status4;
            that.status5 = json.status5;
            that.status6 = json.status6;
            that.today_order_money = json.today_order_money;
            that.today_order_number = json.today_order_number;
            that.today_shop_order_money = json.today_shop_order_money;
            that.today_shop_order_number = json.today_shop_order_number;
            that.shop_seven_days_money = json.shop_seven_days_money;
            that.shop_yesterday_order_money = json.shop_yesterday_order_money;
            that.shop_product = json.shop_product;
            that.shop_selling = json.shop_selling;
            that.shop_not_selling = json.shop_not_selling;
            that.today_user = json.today_user;
            that.yesterday_order_money = json.yesterday_order_money;
            that.yesterday_user = json.yesterday_user;
            that.now_week_money = json.now_week_money;
            that.last_week_money = json.last_week_money;
            that.now_month_money = json.now_month_money;
            that.last_month_money = json.last_month_money;
            that.now_month_user = json.now_month_user;
          }else if(res.data.code == 403)
          {
              this.role = false
          }
        });
    },
    ////////////订单总计
    week() {
      //周

      const that = this;
      var d = new Date(this.week1);
      var week =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " ";
      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: week
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    month() {
      //月
      const that = this;
      var d = new Date(this.month1);
      var month = d.getFullYear() + "-" + (d.getMonth() + 1);

      if (month.length == 6) {
        var month = d.getFullYear() + "-" + "0" + (d.getMonth() + 1);
      }

      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: month
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    year() {
      //年

      const that = this;
      var year = String(this.year1).slice(10, 15);
      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: year
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setData() {
      //本周
      this.stuct = true;
      this.stuct1 = false;
      this.stuct2 = false;
      const that = this;

      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "week"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setData1() {
      //月
      this.stuct = false;
      this.stuct1 = true;
      this.stuct2 = false;
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "month"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setData2() {
      //年
      this.stuct = false;
      this.stuct1 = false;
      this.stuct2 = true;
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/admin_index_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "year"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartData = [];
            for (var key in res.data.data) {
              that.chartData.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    /////////////销售统计
    weeks() {
      //周

      const that = this;
      var d = new Date(this.weeks1);
      var week =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " ";
      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: week
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];

            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    months() {
      //月
      const that = this;
      var d = new Date(this.months1);
      var month = d.getFullYear() + "-" + (d.getMonth() + 1);

      if (month.length == 6) {
        var month = d.getFullYear() + "-" + "0" + (d.getMonth() + 1);
      }

      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: month
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];
            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    years() {
      //年

      const that = this;
      var year = String(this.years1).slice(10, 15);
      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: year
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];
            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setDatas() {
      //本周
      this.stuct01 = true;
      this.stuct11 = false;
      this.stuct21 = false;
      const that = this;

      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "week"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];
            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setDatas1() {
      //月
      this.stuct01 = false;
      this.stuct11 = true;
      this.stuct21 = false;
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "month"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];
            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    },
    setDatas2() {
      //年
      this.stuct01 = false;
      this.stuct11 = false;
      this.stuct21 = true;
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      this.axios
        .get(this.serve + "/admin/sell_money_map", {
          params: {
            username: this.username,
            token: this.token,
            type: "year"
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.chartDatas = [];
            for (var key in res.data.data) {
              if (res.data.data[key].value == null) {
                res.data.data[key].value = 0;
              }
              that.chartDatas.push({
                title: res.data.data[key].title,
                value: res.data.data[key].value
              });
            }
          }
        });
    }
  },
  mounted() {
    this.$store.state.topActiveId = 1;
    this.$store.state.leftTitle = "系统首页";
    this.setData();
    this.setDatas();
    this.geting();
  },
  created() {
    this.$store.state.topActiveId = 1;
    this.$store.state.leftTitle = "系统首页";
    this.setData();
    this.setDatas();
    this.geting();
  },
  computed: {
    myStyles() {
      return {
        height: "320px",
        position: "relative"
      };
    }
  }
};
</script>
<style lang="scss">
.list {
  min-width: 1200px;
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    display: flex;
    margin-bottom: 40px;
    .subTitle {
      width: 1056px;
      margin: 0 auto;
      font-size: 14px;
      position: relative;
      .rutun {
        width: 78px;
        height: 28px;
        background: #fff;
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        margin-top: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }
      .rutun:hover {
        color: #0099ff;
      }
    }
  }
  .pandect {
    display: flex;
    justify-content: space-between;
    .pandect_list {
      display: flex;
      align-items: center;
      width: 249px;
      height: 100px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      .pandect_icon {
        color: #0099ff;
        margin-left: 16px;
      }
      .pandect_center {
        .num{
          font-size: 16px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        margin-left: 16px;
        > p {
          margin: 0;
          font-size: 16px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 4px;
        }
        > span {
          font-size: 16px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
  .pending {
    margin-top: 30px;
    .pending_head {
      width: 98.4%;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
      padding-left: 16px;
    }
    .pending_center {
      display: flex;
      justify-content: space-between;
      background: #fff;
      .pending_center_div {
        padding: 0 10px 20px 10px;
        .pending_center_div1 {
          width: 320px;
          height: 50px;
          border-bottom: 1px solid #dddddd;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > span {
            font-size: 14px;
            > i {
              font-style: normal;
              color: #f76f7d;
            }
          }
        }
      }
      .pending_center_div2 {
        width: 212px;
        height: 164px;
        cursor: pointer;
        text-align: center;
        color: #999999;
      }
      .pending_center_div2:hover {
        background: rgba(238, 238, 238, 1);
        color: #3498db;
      }
    }
  }
  .comm {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .comm_div {
      width: 519px;
      height: 210px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      .comm_head {
        width: 502px;
        height: 46px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        line-height: 46px;
        padding-left: 16px;
      }
      .comm_center {
        display: flex;
        justify-content: space-around;

        margin-top: 46px;
        // margin: 0 auto;
        > div {
          text-align: center;
          >p{
            text-align: left;
          }
          > span {
            font-size: 30px;
            font-family: "MicrosoftYaHei";
            font-weight: 400;
            color: rgba(246, 78, 98, 1);
          }
        }
      }
      .comm_m_top{
        margin-top: 12px;
        .num{
            font-family: "MicrosoftYaHei";
            font-weight: 400;
            color: rgba(246, 78, 98, 1);
        }
      }
    }
  }
  .order {
    margin-top: 30px;
    .order_head {
      width: 98.4%;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
      padding-left: 16px;
    }
    .order_center {
      display: flex;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      background: #fff;
      .order_left {
        width: 180px;
        border-right: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .order_left_top1 {
          font-size: 12px;
          font-family: "MicrosoftYaHeiLight";
          font-weight: 300;
          color: rgba(102, 102, 102, 1);
        }
        .order_left_top2 {
          margin-top: 6px;
          font-size: 30px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .order_left_top3 {
          margin-top: 6px;
          font-size: 12px;
        }
      }
      .order_right {
        width: 880px;
        .statistics {
          display: flex;
          justify-content: space-around;
          align-items: center;
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          .statistics_rig_yeay {
            margin-top: 20px;
            > span {
              margin-right: 10px;
              cursor: pointer;
            }
            .active {
              color: #3498db;
            }
            .active1 {
              color: #3498db;
            }
          }
          .statistics_left {
            margin-top: 20px;
          }
          .statistics_rig {
            margin-top: 20px;
            .container {
              display: flex;
              align-items: center;
              width: 90%;
            }
          }
        }
      }
    }
  }
}
</style>